import { createFileRoute } from "@tanstack/react-router";

import { WorldSettingsPanel } from "../components/settings/WorldSettings";

function SettingsWorldRoute() {
  return <WorldSettingsPanel />;
}

export const Route = createFileRoute("/settings/world")({
  component: SettingsWorldRoute,
});
